import { render, staticRenderFns } from "./CanceledTab.vue?vue&type=template&id=046691f4"
import script from "./CanceledTab.vue?vue&type=script&lang=js"
export * from "./CanceledTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports